import { z } from 'zod';

const viteEnvSchema = z.object({
  VITE_API_BASE_URL: z.string().default(''),
  VITE_LAMBDA_PREFIX: z.string().default('false'),
  VITE_REWARD_ENDPOINT: z.string().default(''),
  VITE_HORIZON_API_BASE_URL: z.string().default(''),
  VITE_PROMOTER_API_BASE_URL: z.string().default(''),
  VITE_NOVO_API_BASE_URL: z.string().default(''),
});

const viteEnv = viteEnvSchema.parse({
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_LAMBDA_PREFIX: import.meta.env.VITE_LAMBDA_PREFIX,
  VITE_REWARD_ENDPOINT: import.meta.env.VITE_REWARD_ENDPOINT,
  VITE_HORIZON_API_BASE_URL: import.meta.env.VITE_HORIZON_API_BASE_URL || '',
  VITE_PROMOTER_API_BASE_URL: import.meta.env.VITE_PROMOTER_API_BASE_URL || '',
  VITE_NOVO_API_BASE_URL: import.meta.env.VITE_NOVO_API_BASE_URL || '',
});

export const appConfig = {
  api: {
    baseUrl: viteEnv.VITE_API_BASE_URL,
    lambdaPrefix: viteEnv.VITE_LAMBDA_PREFIX === 'true' ? '/lambda' : '',
    rewardEndpoint: viteEnv.VITE_REWARD_ENDPOINT,
    horizonApiBaseUrl: viteEnv.VITE_HORIZON_API_BASE_URL,
    promoterApiBaseUrl: viteEnv.VITE_PROMOTER_API_BASE_URL,
    novoApiBaseUrl: viteEnv.VITE_NOVO_API_BASE_URL,
  },
} as const;
